export const menuItems = [
	{ label: "Home", href: "/" },
	{ label: "Works", href: "/portfolio" },
	{ label: "About", href: "/about" },
	{ label: "Contact", href: "/contact" },
];

export const socialLinks = [
	{ label: "Instagram", href: "/#" },
	{ label: "Twitter", href: "/#" },
	{ label: "LinkedIn", href: "/#" },
];
